import { useCurrentProjectId } from "@adsk/alloy-provider";
import { useMemo } from "react";
import { getAccHostname } from "@adsk/acc-issues-core/utils/browser/getAccHostname";

export const useLocationsMapUrl = ({
  issueId,
  mode,
}: {
  issueId?: string;
  mode?: string;
}) => {
  const projectId = useCurrentProjectId();

  return useMemo(() => {
    const path = `https://${getAccHostname()}/locations/projects/${projectId}/map`;

    let search = "?entityType=issues";

    if (issueId) {
      search += `&selectedEntityId=${issueId}`;
    }

    if (mode) {
      search += `&mode=${mode}`;
    }

    return `${path}${search}`;
  }, [issueId, mode, projectId]);
};
